//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
export default {
  props: {
    spec: {
      type: Object,
      required: true
    }
  },
  computed: {
    value_in_percentage: function value_in_percentage() {
      return this.spec.value * 100;
    }
  }
};